import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';
import UserStore from 'stores/UserStore';
import { NOTIFICATION_TYPE } from 'enum/messages';
import allUserGroups from 'enum/userGroups';
import { chatFontSettings } from 'utils/helpers';

import videoIcon from '../../../images/mobileNotificationsChat/vid-graphic.png';

import styles from './ChatNotificationsTypes.css';


const MESSAGE_FROM_ANON_MODE_TYPE = '1';

const VideoMobileNotification = (props) => {
  const { message, isDesktop, chatSettings } = props;

  const { user: { tokenUpchargePercentage } } = UserStore;

  const descriptionText = useMemo(() => {
    let username = message.senderOriginalUsername;
    if (message.anonymous === MESSAGE_FROM_ANON_MODE_TYPE) {
      username = translate('tipping.an.anonymous.user');
    }

    const priceIsOne = message.videoPrice === 1;

    let baseTranslate = undefined;
    if (message.type === NOTIFICATION_TYPE.MARKETPLACE_BULK_PURCHASE) {
      if (priceIsOne) {
        baseTranslate = 'v2profile.notifications.all.videos.single.token';
      } else {
        baseTranslate = 'v2profile.notifications.all.videos.bought';
      }
    } else if (priceIsOne) {
      baseTranslate = 'v2profile.notification.bought.video.single.token';
    } else {
      baseTranslate = 'v2profile.chat.notification.video.bought';
    }

    const notificationClass = classNames({
      [styles.yellowText]: !isDesktop,
    });

    if (
      UserStore.hasCF(allUserGroups.USE_UPCHARGE) &&
      tokenUpchargePercentage
    ) {
      return translate(baseTranslate, {
        0: `<b class=${notificationClass}>${username}</b>`,
        1: '',
        2: '',
      });
    }

    if (priceIsOne) {
      return translate(baseTranslate, {
        0: `<b class=${notificationClass}>${username}</b>`,
        1: `<span class=${notificationClass}>(<b>${message.videoPrice}`,
        2: '</b>)</span>',
      });
    }

    return translate(baseTranslate, {
      0: `<b class=${notificationClass}>${username}</b>`,
      1: `<span class=${notificationClass}>(<b>${message.videoPrice}`,
      2: `${translate('v2profile.tipping.token.plural')}</b>)</span>`,
    });
  }, [
    isDesktop,
    message?.anonymous,
    message?.senderOriginalUsername,
    message?.type,
    message?.videoPrice,
    tokenUpchargePercentage,
  ]);

  const videoWrapClasses = classNames({
    [styles.videoWrap]: true,
    [styles.videoWrapDesktop]: isDesktop,
  });

  const iconClasses = classNames({
    [styles.notifImg]: !isDesktop,
  });

  const textClass = classNames({
    [styles.videoTextDesktop]: isDesktop,
    [styles.videoText]: !isDesktop,
  });

  return (
    <div className={videoWrapClasses}>
      <img
        alt="video"
        className={iconClasses}
        src={videoIcon}
      />
      <div
        className={textClass}
        style={chatFontSettings(isDesktop, chatSettings)}
      >
        {descriptionText}
      </div>
    </div>
  );
};

VideoMobileNotification.propTypes = {
  chatSettings: PropTypes.object,
  isDesktop: PropTypes.bool,
  message: PropTypes.object,
};

VideoMobileNotification.defaultProps = {
  chatSettings: undefined,
  isDesktop: undefined,
  message: undefined,
};

export default VideoMobileNotification;
